export default __webpack_public_path__ + "static/media/TERMINAL_ICON_10.930e4963.svg";